const canUseDOM = typeof document !== "undefined";

// eslint-disable-next-line import/no-mutable-exports
let publicConfig = {};

if (canUseDOM && window[`PUBLIC_CONFIG_${process.env.CURRENT_HOST}`]) {
  const handler = {
    get(target, property) {
      if (!target[property]) {
        // used for federated config loading to work around webpack object cache
        if (window[`PUBLIC_CONFIG_${process.env.CURRENT_HOST}`]) {
          return window[`PUBLIC_CONFIG_${process.env.CURRENT_HOST}`][property];
        }
        return null;
      }
      return target[property];
    },
  };

  publicConfig =
    window[`PUBLIC_CONFIG_${process.env.CURRENT_HOST}`] ||
    new Proxy(publicConfig, handler);
} else if (global[`PUBLIC_CONFIG_${process.env.CURRENT_HOST}`]) {
  const configProxy = {
    get(config, prop) {
      if (!config[prop])
        return global[`PUBLIC_CONFIG_${process.env.CURRENT_HOST}`][prop];
      return config[prop];
    },
  };

  publicConfig = new Proxy(
    global[`PUBLIC_CONFIG_${process.env.CURRENT_HOST}`],
    configProxy
  );
} else if (global.PR_PUBLIC_CONFIG) {
  publicConfig = global.PR_PUBLIC_CONFIG;
} else if (global.PUBLIC_CONFIG) {
  const configProxy = {
    get(config, prop) {
      if (!config[prop]) return global.PUBLIC_CONFIG[prop];
      return config[prop];
    },
  };

  publicConfig = new Proxy(global.PUBLIC_CONFIG, configProxy);
}

export default publicConfig;
